setTimeout(function() {
    $("input[type=tel]").mask("(99) 99999-9999");
    $("input[name='telefone']").mask("(99) 99999-9999");
    $("input[name='celular']").mask("(99) 99999-9999");
}, 3000);